import { Trash2Icon, X } from "lucide-react";
import React, { useState, useRef, useEffect } from "react";
import { FaTrash } from "react-icons/fa";
import { FaPencil } from "react-icons/fa6";
import { Outlet, Link, useLocation, useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';
import Sidebar from "../../components/Sidebar";


function ContactData() {

  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [imageFile, setImageFile] = useState(null);

  const [contactData, setContactData] = useState({
    phone: "",
    email: "",
    address: "",
    whatsapp1: "",
    whatsapp2: "",
    whatsapp3: "",
    telegram: "",
    instagram: "",
    tiktok: "",
    youtube: "",
    facebook: "",
  });

  const onChangeRunning = (e) => {
    const { name, value } = e.target;

    setContactData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };


  const fetchContactData = async () => {

    try {
        const res = await fetch(
            `${process.env.REACT_APP_BASE_URL}api/contactdata/1`
        );

        if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);

        const json = await res.json();
        setContactData(json.data || []);

    } catch (err) {
        console.error("Fetch Pc error:", err);
    }
  };

  useEffect(() => {
    fetchContactData();
  }, []);

  const updateContactData = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const formData = new FormData();

      // append text fields
      formData.append("phone", contactData.phone);
      formData.append("email", contactData.email);
      formData.append("address", contactData.address);
      formData.append("whatsapp1", contactData.whatsapp1);
      formData.append("whatsapp2", contactData.whatsapp2);
      formData.append("whatsapp3", contactData.whatsapp3);
      formData.append("telegram", contactData.telegram);
      formData.append("instagram", contactData.instagram);
      formData.append("tiktok", contactData.tiktok);
      formData.append("youtube", contactData.youtube);
      formData.append("facebook", contactData.facebook);

      const res = await fetch(
        `${process.env.REACT_APP_BASE_URL}api/contactdata/1`,
        {
          method: "POST",
          body: formData, // 
        }
      );

      if (!res.ok) throw new Error("Gagal update");

      const result = await res.json();

      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "success",
        title: "Data berhasil diperbarui!",
        showConfirmButton: false,
        timer: 3000,
      });

    } catch (err) {
      Swal.fire("Error", "Gagal update data", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-950 text-white pt-20">
      {/* Header Section */}
      <section 
        data-section="header"
        className="py-24 bg-gradient-to-b from-slate-900 to-slate-950 relative overflow-hidden"
      >
        <div className="absolute inset-0">
          <img
            src="/images/bg-hero-about-us.jpeg"
            alt="background"
            className="w-full h-full object-cover opacity-20"
          />
        </div>

        <div className={`relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center transition-all duration-1000 opacity-100 translate-y-0
        }`}>
          <h1 className="font-bricolage text-5xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-blue-400 to-red-400 bg-clip-text text-transparent">
            Halaman Admin
          </h1>
          <div className="w-24 h-1 bg-gradient-to-r from-blue-500 to-red-500 mx-auto mb-6"></div>
        </div>
      </section>
      <section 
        data-section="contact"
        className="py-24 bg-slate-950"
      >
        <div className='flex flex-row max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 transition-all duration-1000 delay-200'>
          <div className='w-1/4'>
            <Sidebar></Sidebar>
          </div>
          <div className='w-3/4 p-4 bg-gray-800 text-white flex-col md:relative md:flex rounded-3xl '>
            <div className='flex flex-col'>
              <div className='p-4 text-xl font-medium'>
                Contact Data, Social Media
              </div>
              <div className='flex flex-row'>
                <div className='w-1/2 p-4'>
                  <label className="block mb-1 font-medium ">Email</label>
                  <input
                    type="text"
                    name="email"
                    className="w-full text-black border px-3 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    value={contactData?.email}
                    onChange={onChangeRunning}
                    required
                  />
                </div> 
                <div className='w-1/2 p-4'>
                  <label className="block mb-1 font-medium ">Telpon</label>
                  <input
                    type="text"
                    name="phone"
                    className="w-full text-black border px-3 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    value={contactData?.phone}
                    onChange={onChangeRunning}
                    required
                  />
                </div>  
              </div>
              <div className="flex">
                <div className='w-full p-4'>
                  <label className="block mb-1 font-medium ">Alamat</label>
                  <textarea
                    name="address"
                    rows="4"
                    className="w-full text-black border px-3 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    onChange={onChangeRunning}
                    value={contactData?.address}
                  >
                    {contactData?.address}
                  </textarea>
                </div>                
              </div>

              <div className='flex flex-row'>
                <div className='w-1/3 p-4'>
                  <label className="block mb-1 font-medium ">Whatsapp 1</label>
                  <input
                    type="text"
                    name="whatsapp1"
                    className="w-full text-black border px-3 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    value={contactData?.whatsapp1}
                    onChange={onChangeRunning}
                    required
                  />
                </div> 
                <div className='w-1/3 p-4'>
                  <label className="block mb-1 font-medium ">Whatsapp 2</label>
                  <input
                    type="text"
                    name="whatsapp2"
                    className="w-full text-black border px-3 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    value={contactData?.whatsapp2}
                    onChange={onChangeRunning}
                    required
                  />
                </div>              
                <div className='w-1/3 p-4'>
                  <label className="block mb-1 font-medium ">Whatsapp 3</label>
                  <input
                    type="text"
                    name="whatsapp3"
                    className="w-full text-black border px-3 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    value={contactData?.whatsapp3}
                    onChange={onChangeRunning}
                    required
                  />
                </div>                
              </div>
              <div className='flex flex-row'>
                <div className='w-1/2 p-4'>
                  <label className="block mb-1 font-medium ">Instagram</label>
                  <input
                    type="text"
                    name="instagram"
                    className="w-full text-black border px-3 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    value={contactData?.instagram}
                    onChange={onChangeRunning}
                    required
                  />
                </div> 
                <div className='w-1/2 p-4'>
                  <label className="block mb-1 font-medium ">Tiktok</label>
                  <input
                    type="text"
                    name="tiktok"
                    className="w-full text-black border px-3 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    value={contactData?.tiktok}
                    onChange={onChangeRunning}
                    required
                  />
                </div>                
              </div>
              <div className='flex flex-row'>
                <div className='w-1/2 p-4'>
                  <label className="block mb-1 font-medium ">Youtube</label>
                  <input
                    type="text"
                    name="youtube"
                    className="w-full text-black border px-3 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    value={contactData?.youtube}
                    onChange={onChangeRunning}
                    required
                  />
                </div> 
                <div className='w-1/2 p-4'>
                  <label className="block mb-1 font-medium ">Facebook</label>
                  <input
                    type="text"
                    name="facebook"
                    className="w-full text-black border px-3 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    value={contactData?.facebook}
                    onChange={onChangeRunning}
                    required
                  />
                </div>                
              </div>
              <div className='flex flex-row'>
                <div className='w-1/2 p-4'>
                  <label className="block mb-1 font-medium ">Telegram</label>
                  <input
                    type="text"
                    name="telegram"
                    className="w-full text-black border px-3 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    value={contactData?.telegram}
                    onChange={onChangeRunning}
                    required
                  />
                </div>         
              </div>
              <div className='flex flex-row'>
                <div className='w-1/3 p-4'>
                  <button onClick={updateContactData} className='p-4 rounded-full bg-gradient-to-r from-blue-600/30 to-red-600/30 hover:shadow-xl hover:shadow-blue-500/50 transform hover:scale-105 transition-all duration-300'>Simpan</button>
                </div>
              </div>
            </div>
            
          </div>
          
        </div>
      </section>
      
    </div>
  );
}

export default ContactData;
